/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TeamsControllerFindOneQueryResponse, TeamsControllerFindOnePathParams, TeamsControllerFindOneQueryParams, TeamsControllerFindOne400, TeamsControllerFindOne401, TeamsControllerFindOne403, TeamsControllerFindOne404 } from "../../models/teamsController/TeamsControllerFindOne";

function getTeamsControllerFindOneUrl(id: TeamsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/teams/${id}` as const }  
  return res
}

/**
 * @summary Get team by id
 * {@link /api/v1/teams/:id}
 */
export async function teamsControllerFindOne(id: TeamsControllerFindOnePathParams["id"], params?: TeamsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TeamsControllerFindOneQueryResponse, ResponseErrorConfig<TeamsControllerFindOne400 | TeamsControllerFindOne401 | TeamsControllerFindOne403 | TeamsControllerFindOne404>, unknown>({ method : "GET", url : getTeamsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}